<!--			 	 -->
<!-- Click-Once List -->
<!-- 			 	 -->
<div class="deploy-group-item" style="margin-bottom: 30px">
	<div class="plugin-info-div">
		<div style="margin-bottom: 20px">
			<label class="deploy-group-title-div">Supported Browsers</label>
			<label class="deploy-group-title-div" style="margin-left: 10px">(Windows 10 Only)</label>
		</div>

		<div class="plugin-info-div-h">
			<div>1. Microsoft Edge Chromium</div>
			<div style="margin-left: 15px; font-weight: normal">No plugin needed</div>
		</div>

		<div class="plugin-info-div-h">
			<div>2. Google Crome</div>
			<div style="margin-left: 15px; font-weight: normal">
				Must add the Extension/Plugin [<a
					href="https://chrome.google.com/webstore/detail/meta4-clickonce-launcher/jkncabbipkgbconhaajbapbhokpbgkdc?hl=en"
					>Meta4 ClickOnce Launcher</a
				>]
			</div>
		</div>

		<div class="plugin-info-div-h">
			<div>3. Firefox</div>
			<div style="margin-left: 15px; font-weight: normal">
				Must add the Extension/Plugin [<a
					href="https://addons.mozilla.org/en-US/firefox/addon/breez-clickonce/?utm_source=addons.mozilla.org&utm_medium=referral&utm_content=search"
					>Breez ClickOnce Launcher</a
				>]
			</div>
		</div>
	</div>
</div>

<div class="deploy-group-item">
	<div class="deploy-group-item-div">
		<label>ID Card Designer</label>
	</div>

	<div style="margin-left: 15px">
		<button class="btn btn-primary button-center" (click)="onCAASSPhotoIDDeploy()" [disabled]="isBusy == true">Launch</button>
	</div>
</div>

<!-- 				   -->
<!-- Display When Busy -->
<!-- 				   -->
<div style="padding: 20px" [style.display]="isBusy == true ? 'block' : 'none'">
	<img class="busy-img" src="assets/images/loading.gif" />
</div>
